// Libs
import React, { FC, PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

import Text from 'core/elements/Text'
import generateTestId from 'utils/test-helpers'
import CardBody from 'core/elements/card/CardBody'
import Card from 'core/elements/card'

interface Props {
  message?: string
  defaultHeight?: number
}

const useStyles = makeStyles<Theme>((theme) => ({
  messageContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}))

export default function NoContentMessage({
  children,
  message,
  defaultHeight = 200,
}: PropsWithChildren<Props>) {
  const classes = useStyles()
  return (
    <Card withCustomBody>
      <CardBody>
        <div className={classes.messageContainer} style={{ minHeight: `${defaultHeight}px` }}>
          {message ? (
            <Text data-testid={generateTestId('no', 'data', 'found')} variant="subtitle2">
              {message}
            </Text>
          ) : (
            children
          )}
        </div>
      </CardBody>
    </Card>
  )
}
